"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.alertCategory = void 0;
exports.createAlertMessage = createAlertMessage;
exports.createResponseAlertMessage = createResponseAlertMessage;
exports.default = void 0;
var _freeze = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/freeze"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/map"));
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _now = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/date/now"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/keys"));
var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _entries = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/entries"));
var _react = _interopRequireDefault(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactIntl = require("react-intl");
var _copyTextToClipboard = _interopRequireDefault(require("../../utils/copyTextToClipboard"));
var _AutoIntl = _interopRequireDefault(require("../elements/AutoIntl"));
var _AuButton = _interopRequireWildcard(require("../elements/AuButton"));
var _context, _context3;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "alert_message": "alert_message-module__alert_message___L6_rB",
  "inner": "alert_message-module__inner___y5J3W",
  "inner_title": "alert_message-module__inner_title___n9dmk",
  "title": "alert_message-module__title___V9CM9",
  "new": "alert_message-module__new____YiL7",
  "move-in": "alert_message-module__move-in___b6Hkb",
  "dismissed": "alert_message-module__dismissed___CkzOE",
  "fade-out": "alert_message-module__fade-out___KqHua",
  "alert": "alert_message-module__alert___qgVQv",
  "info": "alert_message-module__info___KWSoA alert_message-module__alert___qgVQv",
  "warning": "alert_message-module__warning___ADTRc alert_message-module__alert___qgVQv",
  "copybtn": "alert_message-module__copybtn___RtrGQ",
  "dismissbtn": "alert_message-module__dismissbtn___SLS0P",
  "error": "alert_message-module__error___kGCXx alert_message-module__alert___qgVQv",
  "message": "alert_message-module__message___Pfjn_",
  "help_container": "alert_message-module__help_container___G_WDl",
  "button_wrapper": "alert_message-module__button_wrapper___vU63V",
  "email": "alert_message-module__email___W2QZr",
  "link": "alert_message-module__link___gh_pC alert_message-module__email___W2QZr",
  "copied": "alert_message-module__copied___RATnK",
  "dismiss_container": "alert_message-module__dismiss_container___H0P5v",
  "dismiss_btn": "alert_message-module__dismiss_btn___plxQJ",
  "hide": "alert_message-module__hide___pTovT"
};
const EVENT_NAME = 'newAlertMessage';
const alertCategory = exports.alertCategory = (0, _freeze.default)({
  info: 'info',
  warning: 'warning',
  error: 'error'
});
function createAlertMessage({
  category,
  titleId,
  titleString,
  messageId,
  messageValues,
  messageString,
  helpId,
  helpValues,
  messageClassName,
  hideCopyBtn
}) {
  if (!alertCategory[category]) {
    /* eslint-disable no-console */
    console.warn('Invalid or missing category.');
    /* eslint-enable no-console */
    return;
  }
  if (!messageId && !messageString) {
    /* eslint-disable no-console */
    console.warn('Both messageId and messageString are empty.');
    /* eslint-enable no-console */
    return;
  }
  window.dispatchEvent(new CustomEvent(EVENT_NAME, {
    detail: {
      category,
      titleId,
      titleString,
      messageId,
      messageValues,
      messageString,
      helpId,
      helpValues,
      messageClassName,
      hideCopyBtn
    }
  }));
}

// assume a 4xx error
function createResponseAlertMessage(resp) {
  if (resp == 'clearEvents') {
    return window.dispatchEvent(new CustomEvent(EVENT_NAME, {
      detail: resp
    }));
  }
  let errorTitle = (resp.data || {}).error;
  const errorMessage = resp?.message ? resp.message : (resp.data || {}).message;
  const responseStatus = resp.status; // use headers response status and not api response

  let helpId;
  let helpValues;
  switch (responseStatus) {
    case 400:
      helpId = 'au.errors.400.help';
      break;
    case 401:
      helpId = 'au.errors.401.help';
      break;
    case 403:
      helpId = 'au.errors.403.help';
      helpValues = {
        link: /*#__PURE__*/_react.default.createElement("a", {
          href: 'https://developer.autonomic.ai/api-reference/authentication/overview-of-authentication',
          target: "_blank"
        }, /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
          displayId: "au.requestPermissions",
          className: styles.link
        }))
      };
      break;
    case 404:
      helpId = 'au.errors.404.help';
      helpValues = {
        iamLink: /*#__PURE__*/_react.default.createElement("a", {
          href: 'https://developer.autonomic.ai/api-reference/iam-service/iam-service-reference#overview',
          target: "_blank"
        }, /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
          displayId: "au.requestPermissions",
          className: styles.link
        }))
      };
      break;
    case 405:
      helpId = 'au.errors.405.help';
      break;
    case 408:
      helpId = 'au.errors.help';
      break;
    case 409:
      helpId = 'au.errors.409.help';
      helpValues = {
        email: /*#__PURE__*/_react.default.createElement("a", {
          href: "mailto:tmchelp@ford.com",
          className: styles.email
        }, "tmchelp@ford.com")
      };
      break;
    case 410:
      helpId = 'au.errors.410.help';
      helpValues = {
        email: /*#__PURE__*/_react.default.createElement("a", {
          href: "mailto:tmchelp@ford.com",
          className: styles.email
        }, "tmchelp@ford.com")
      };
      break;
    case 415:
      helpId = 'au.errors.415.help';
      break;
    case 422:
      errorTitle = /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
        displayId: "au.errors.422.title"
      });
      helpId = 'au.errors.422.help';
      break;
    case 429:
      helpId = 'au.errors.help';
      break;
    case 503:
      helpId = 'au.errors.503.help';
      break;
    case 504:
      helpId = 'au.errors.504.help';
      helpValues = {
        email: /*#__PURE__*/_react.default.createElement("a", {
          href: "mailto:tmchelp@ford.com",
          className: styles.email
        }, "tmchelp@ford.com")
      };
      break;
  }
  createAlertMessage({
    category: alertCategory.error,
    titleId: errorTitle ? undefined : 'au.errors.400.title',
    titleString: errorTitle || '',
    messageId: errorMessage ? undefined : 'au.error.generic',
    messageString: errorMessage || '',
    helpId,
    helpValues,
    hideCopyBtn: false
  });
}
class AlertMessage extends _react.default.PureComponent {
  static propTypes = {
    className: T.string,
    maxMessages: T.number
  };
  static defaultProps = {
    maxMessages: 3
  };
  state = {
    messages: new _map.default(),
    counter: 0,
    dismissAll: false
  };
  componentDidMount() {
    window.addEventListener(EVENT_NAME, this.processNewMessage);
  }
  componentWillUnmount() {
    window.removeEventListener(EVENT_NAME, this.processNewMessage);
  }
  processNewMessage = (0, _bind.default)(_context = this.processNewMessage).call(_context, this);
  processNewMessage({
    detail
  }) {
    if (detail == 'clearEvents') {
      this.removeAll();
    }
    // validate message object first
    if (detail && detail.category && (detail.messageId || detail.messageString)) {
      this.setState(prevState => {
        var _context2;
        const messages = new _map.default(prevState.messages);
        const id = prevState.counter;
        // logging timestamp just in case
        messages.set(id, {
          ...detail,
          timestamp: (0, _now.default)(),
          new: true
        });
        // get all not dismissed messages
        const visibleMessageIds = (0, _filter.default)(_context2 = [...(0, _keys.default)(messages).call(messages)]).call(_context2, id => !messages.get(id).dismissed);
        // difference between visible messages and max allowed messages
        const diff = visibleMessageIds.length - this.props.maxMessages;
        if (diff > 0) {
          for (let i = 0; i < diff; i++) {
            this.dismissMessage(visibleMessageIds[i]);
          }
        }
        return {
          counter: id + 1,
          messages
        };
      });
    } else {
      /* eslint-disable no-console */
      console.warn('Invalid message format: ', detail);
      /* eslint-enable no-console */
    }
  }

  copyErrorMessage(id, messageString) {
    (0, _copyTextToClipboard.default)(messageString);
    const toggleCopied = callback => this.setState(prevState => {
      const messages = new _map.default(prevState.messages);
      const message = messages.get(id);
      if (message) {
        messages.set(id, {
          ...message,
          copied: !message.copied
        });
        return {
          messages
        };
      }
      return null;
    }, callback);

    // toggle on - show copied message
    toggleCopied(
    // wait 4 sec
    () => (0, _setTimeout2.default)(
    // toggle off - hide copied message
    () => toggleCopied(), 4000));
  }
  dismissMessage(id) {
    this.setState(prevState => {
      const messages = new _map.default(prevState.messages);
      // 1. mark message as dismissed to activate fade-out animation
      messages.set(id, {
        ...messages.get(id),
        dismissed: true,
        new: undefined
      });
      return {
        messages
      };
    },
    // 2. wait till animation is complete
    () => (0, _setTimeout2.default)(() =>
    // 3. remove message
    this.removeMessage(id), 400));
  }
  removeMessage(id) {
    this.setState(prevState => {
      const messages = new _map.default(prevState.messages);
      messages.delete(id);
      return {
        messages
      };
    });
  }
  dismissAll = (0, _bind.default)(_context3 = this.dismissAll).call(_context3, this);
  dismissAll() {
    this.setState({
      dismissAll: true
    });
    this.setState(prevState => {
      const messages = new _map.default(prevState.messages);
      // 1. mark message as dismissed to activate fade-out animation
      (0, _forEach.default)(messages).call(messages, message => message.dismissed = true);
      return {
        messages
      };
    },
    // 2. wait till animation is complete
    () => (0, _setTimeout2.default)(() =>
    // 3. remove message
    this.removeAll(), 700));
  }
  removeAll() {
    this.setState({
      messages: new _map.default(),
      counter: 0,
      dismissAll: false
    });
  }
  renderMessage(id, message) {
    var _context4, _context5;
    const {
      titleId,
      titleString,
      messageId,
      messageString,
      messageValues,
      helpId,
      helpValues,
      messageClassName,
      hideCopyBtn
    } = message;
    const classNames = (0, _classnames.default)(styles[message.category], styles.alert_message, {
      [styles.new]: message.new,
      [styles.dismissed]: message.dismissed
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      key: `alert_msg_${id}`,
      className: classNames
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: styles.inner
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: styles.inner_title
    }, (titleId || titleString) && /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      className: styles.title,
      displayId: titleId,
      displayString: titleString,
      tag: "div"
    }), /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      className: (0, _classnames.default)(styles.message, messageClassName),
      displayId: messageId,
      displayString: messageString,
      values: messageValues,
      tag: "div"
    })), helpId && /*#__PURE__*/_react.default.createElement("div", {
      className: styles.help_container
    }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
      id: helpId,
      values: helpValues,
      tag: "div"
    }))), !hideCopyBtn && /*#__PURE__*/_react.default.createElement("div", {
      className: styles.button_wrapper
    }, !message.copied && /*#__PURE__*/_react.default.createElement(_AuButton.default, {
      type: _AuButton.BUTTON_TYPE_TERTIARY,
      size: _AuButton.BUTTON_SIZE_MEDIUM,
      displayId: "au.userProfile.copyToken",
      className: styles.copybtn,
      onClick: (0, _bind.default)(_context4 = this.copyErrorMessage).call(_context4, this, id, messageString)
    }), message.copied && /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      displayId: "au.userProfile.copiedToClipboard",
      className: styles.copied,
      tag: "div"
    })), /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: styles.dismissbtn,
      "data-testid": "dismiss-button",
      onClick: (0, _bind.default)(_context5 = this.dismissMessage).call(_context5, this, id)
    }));
  }
  render() {
    const alerts = [];
    let dismissed;
    for (let [id, detail] of (0, _entries.default)(_context6 = this.state.messages).call(_context6)) {
      var _context6;
      alerts.unshift(this.renderMessage(id, detail));
      dismissed = detail.dismissed;
    }
    return /*#__PURE__*/_react.default.createElement("div", null, alerts, alerts.length > 1 && /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.dismiss_container, {
        [styles.hide]: this.state.dismissAll
      })
    }, /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      displayId: 'au.dismissAll',
      className: styles.dismiss_btn,
      onClick: this.dismissAll
    })));
  }
}
exports.default = AlertMessage;